export enum RecaptchaError {
  InvalidRecaptchaV2 = 'RecaptchaV2 token invalid',
  InvalidRecaptchaV3 = 'RecaptchaV3 token invalid',
  MissingRecaptchaV2 = 'RecaptchaV2 token missing',
  MissingRecaptchaV3 = 'RecaptchaV3 token missing',
}

export const ACCOUNT_ALREADY_CONFIRMED = 'auth.accountAlreadyConfirmed';
